import React, { useEffect, useState } from "react";
import classNames from "classnames";
import styles from "./style.module.scss";
import { UIButton, UICheckBox, UIText } from "src/components/uIKit";
import { handleShare, sentPostMessage } from "src/utils/utils";
import { API_RESULT, CHANNELS, CHECKBOX_TYPE, DIGITAL_AGENT_BUTTONS } from "src/utils/enums";
import { useAppDispatch, useAppSelector } from "src/hooks/useRedux";
import { images } from "src/assets/images/images";
import { sendLeadOrSms } from "src/redux/slices/appSlice/AppApi";
import { useIsMobile } from "src/hooks/useIsMobile";

interface DigitalAgentContentProps {
  subTitle?: string;
  body: string;
  strings?: {
    t_digital_agent_contact_button: string;
    t_digital_agent_send_button: string;
    t_digital_agent_dissmis_button: string;
    t_digiral_agent_list_title: string;
    t_digital_agent_item1_title: string;
    t_digital_agent_item2_title: string;
    t_digital_agent_list_sub_title: string;
    t_share_title: string;
    t_share_text: string;
    t_digital_agent_dissmis_button_aria_label: string;
    t_digital_agent_checkbox_text: string;
  };
}

const DigitalAgentContent: React.FC<DigitalAgentContentProps> = ({
  subTitle,
  body,
  strings,
}) => {
  const dispatch = useAppDispatch();
  const isMobile = useIsMobile();
  const {
    businessUnit,
    personalId,
    travelPolicyNumber,
    agentId,
    campaignId,
    campaignName,
    fXEligibilityData,
    sendLeadOrSmsResStatus,
  } = useAppSelector((state) => state.app);
  const [showSmsLoading, setShowSmsLoading] = useState(false);
  const [showPfsRepLoading, setShowPfsRepLoading] = useState(false);
  const [isAcceptChecked, setIsAcceptChecked] = useState(false);
  const [isShareChecked, setIsShareChecked] = useState(false);

  const handleAcceptCheckboxChange = (checked: boolean) => {
    setIsAcceptChecked(!isAcceptChecked);
  };
  useEffect(() => {
    if (sendLeadOrSmsResStatus === API_RESULT.SUCCEEDED) {
      const data = { buttonClicked: DIGITAL_AGENT_BUTTONS.CONTACT_CUSTOMER, status: API_RESULT.SUCCEEDED };
      if (!isShareChecked) {
        sentPostMessage(data);
      }
     
    }else if (sendLeadOrSmsResStatus === API_RESULT.FAILED) {
      const data = { buttonClicked: DIGITAL_AGENT_BUTTONS.CONTACT_CUSTOMER, status: API_RESULT.FAILED };
      if (!isShareChecked) {
        sentPostMessage(data);
      }
    }
  }, [sendLeadOrSmsResStatus]);

  const onContactSubmit = () => {
    setIsShareChecked(false);
    callSendLeadOrSms(CHANNELS.PFS_REP);
   
  };
  const onShareClick = () => {
    setIsShareChecked(true);
    callSendLeadOrSms(CHANNELS.SMS_SHARE);
   
    if (strings)
      handleShare(
        strings.t_share_title,
        strings.t_share_text,
        fXEligibilityData?.sharedLink ?? ""
      );
    // }
  };

  const callSendLeadOrSms = (channel: number) => {
    if (channel === CHANNELS.SMS_SHARE) {
      setShowSmsLoading(true);
    } else if (channel === CHANNELS.PFS_REP) {
      setShowPfsRepLoading(true);
    }
    const requestProperties = {
      feChannel: channel,
      feBU: businessUnit,
      feCustPersId: personalId,
      feCustTravelPolicyNumber: travelPolicyNumber,
      feAgentId: agentId ?? "",
      feCampaignId: channel === CHANNELS.CAMPAIGN ? campaignId : null,
      feCampaignName: channel === CHANNELS.CAMPAIGN ? campaignName : null,
    };
    dispatch(sendLeadOrSms(requestProperties));
  };
  const onDissmisClick = () => {
    const data = { buttonClicked: DIGITAL_AGENT_BUTTONS.BACK_TO_BENEFITS };
    sentPostMessage(data);
  };
  return (
    <div className={styles.errorSubTitleWrapper}>
      <div>
        <div className={styles.mBottom}>
          {subTitle && <UIText text={subTitle} size={22} weight={500} />}
        </div>

        <UIText
          text={body}
          size={18}
          weight={400}
          style={classNames(styles.cardSubTitle, styles.flex1)}
        />
        {strings && (
          <div className={styles.listTitleWrapper}>
            <UIText
              size={18}
              weight={400}
              text={strings.t_digiral_agent_list_title}
            />
            <ul>
              <li>
                <UIText
                  size={18}
                  weight={400}
                  text={strings.t_digital_agent_item1_title}
                />
              </li>
              <li>
                <UIText
                  size={18}
                  weight={400}
                  text={strings.t_digital_agent_item2_title}
                />
              </li>
            </ul>
            <br />
          
          </div>
        )}
      </div>
      <div className={styles.checkboxWrapper}>
        <UICheckBox
          checked={isAcceptChecked}
          onChange={handleAcceptCheckboxChange}
          type={CHECKBOX_TYPE.SQUARE}
          className={styles.checkbox}
        />
        <UIText
          text={strings?.t_digital_agent_checkbox_text ?? ""}
          size={18}
          weight={400}
        />
      </div>
      {strings && (
        <>
          <div className={styles.buttonWrapepr}>
            <div className={styles.digitalAgentButtonsWrapper}>
              <UIButton
                title={strings.t_digital_agent_contact_button}
                onSubmit={onContactSubmit}
                isLoading={sendLeadOrSmsResStatus === API_RESULT.LOADING}
                fullWidth
                disabled={!isAcceptChecked} 
              />
              {isMobile ? <br /> : <div className={styles.spaceBetween}></div>}

              <UIButton
                title={strings.t_digital_agent_send_button}
                onSubmit={onShareClick}
                icon={<img src={images.share} alt="share" width={20} />}
                fullWidth
                // isLoading={showSmsLoading}
                disabled={!isAcceptChecked}
                // style={styles.digitalAgentSendButton}
              />
            </div>
          </div>

          <div className={styles.buttonWrapper}>
            <UIButton
              ariaLabel={strings.t_digital_agent_dissmis_button_aria_label}
              title={strings.t_digital_agent_dissmis_button}
              style={styles.digitalAgentDismissButtonLink}
              onSubmit={onDissmisClick}
              disabled={!isAcceptChecked}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default DigitalAgentContent;
